import React, { Component } from 'react';
import PropTypes from 'prop-types';
import qs from 'qs';
import moment from 'moment';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { OverlayTrigger, Tooltip, Button } from 'react-bootstrap';
import { AgGridReact } from 'ag-grid-react';
import Fa from 'react-fontawesome';
import { delay, map, each } from 'lodash';
import ReactResizeDetector from 'react-resize-detector';

import SearchField from '../../../../components/search-field';
import ProgressBar from '../../../../components/progress-bar';
import TruVoiceResync from '../../../../components/truvoice-resync';
import AddOrganizationButton from '../../components/AddOrganizationButton/AddOrganizationButton';
import InvitationExclusionModal from '../../../Setup/pages/OrganizationPage/InvitationExclusionPage';
import { resetTVProductMappings, resetTVCollectorMappings } from '../../../Setup/SetupActions';
import { resetTVPrograms } from '../../../Nomination/NominationActions';
import OrganizationNameRenderer from '../../../../components/table-cells/OrganizationNameRenderer';
import OrganizationIdRenderer from '../../../../components/table-cells/OrganizationIdRenderer';
import OrganizationTypeRenderer from '../../../../components/table-cells/OrganizationTypeRenderer';
import NumberRenderer from '../../../../components/table-cells/NumberRenderer';
import OrganizationLastSyncRenderer from '../../../../components/table-cells/OrganizationLastSync';
import { dateComparator } from '../../../../components/table-cells/helpers';

import EmptyCellRenderer from '../../../../components/table-cells/EmptyCellRenderer';
import TruVoiceDomainRenderer from './TVDomainRenderer';
import TruVoiceRenderer from './TruVoiceRenderer';
import UserRoleCountRenderer from './UserRoleCountRenderer';
import ActionRenderer from './ActionRenderer';
import BotVersionRenderer from './BotVersionRenderer';
import Veil from '../../../../components/god-table/veil';
import CustomHeader from '../../../../components/god-table/header';

import { getViewableDimensions } from '../../../App/AppReducer';

import TruVoiceClientsAssignModal from '../../components/TruVoiceClientsAssignModal/TruVoiceClientsAssignModal';
import UserRoleListModal from '../../components/UserRoleListModal/UserRoleListModal';
import OrganizationResync from '../../../../components/organization-resync';
import OrganizationDelete from '../../../../components/organization-delete';
import CreateDemoOrganizationButton from '../../components/CreateDemoOrganizationButton/CreateDemoOrganizationButton';
import SyncLogModal from '../../components/SyncLog';
import AppUserModal from '../../components/AzureAppUser';
import ApiUsageModal from '../../components/ApiUsageModal';

import SAMLForm from '../../components/SAMLForm';
import OrganizationSyncPermissions from '../../components/OrganizationSyncPermissions';

// Import Actions
import {
  fetchAllOrganizations,
  fetchTruVoiceClients,
  requestUpdateOrganization,
} from '../../AdminActions';

// Import Selectors
import { getUser } from '../../../Auth/AuthReducer';
import {
  getAllOrganizations,
  getTruVoiceClientsLoading,
  getTruVoiceClientsLoaded,
  getTruVoiceClients,
} from '../../AdminReducer';

class OrganizationIndexPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      error: null,
      deleting: {},
      updating: {},
      showAssignModal: false,
      showUserListByRole: false,
      showEditingModal: false,
      showSyncModal: false,
      showCreateDemoModal: false,
      editingOrganization: null,
      editingInvitationExclusionListOrganization: null,
      fullScreenMode: false,
      topBarHeight: 0,
      showSyncLogOrganization: null,
      selectedRole: '',
      showOrganizationAppUser: null,
      showOrganizationAppUserModal: false,
      showOrganizationSAMLSettings: null,
      showOrganizationSAMLModal: false,
      OrganizationSyncPermissions: null,
      connected: null,
      showApiUsageOrganization: null,
      showApiUsageOrganizationModal: false,
    };
    this.onChangeClientIds = this.onChangeClientIds.bind(this);
    this.sync = this.sync.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.onGridReady = this.onGridReady.bind(this);
    this.onFirstDataRendered = this.onFirstDataRendered.bind(this);
    this.nameColumnCellRendererSelector = this.nameColumnCellRendererSelector.bind(this);
    this.lastSyncedColumnCellRendererSelector = this.lastSyncedColumnCellRendererSelector.bind(this);
    this.estimateColumnCellRendererSelector = this.estimateColumnCellRendererSelector.bind(this);
    this.estimateColumnValueGetter = this.estimateColumnValueGetter.bind(this);
    this.truvoiceColumnCellRendererSelector = this.truvoiceColumnCellRendererSelector.bind(this);
    this.actionColumnCellRendererSelector = this.actionColumnCellRendererSelector.bind(this);
    this.userRoleCountColumnCellRendererSelector = this.userRoleCountColumnCellRendererSelector.bind(this);
    this.handleRequestDelete = this.handleRequestDelete.bind(this);
    this.handleRequestEdit = this.handleRequestEdit.bind(this);
    this.handleRequestSync = this.handleRequestSync.bind(this);
    this.handleRequestCreateDemo = this.handleRequestCreateDemo.bind(this);
    this.requestShowAppUserModal = this.requestShowAppUserModal.bind(this);
    this.requestShowSAMLModal = this.requestShowSAMLModal.bind(this);
    this.handleAddOrg = this.handleAddOrg.bind(this);
    this.handleEditInvitationExclusionList = this.handleEditInvitationExclusionList.bind(this);
    this.apiUsageColumnCellRendererSelector = this.apiUsageColumnCellRendererSelector.bind(this);
    this.onResizeTopBar = this.onResizeTopBar.bind(this);
    this.toggleFullScreenMode = this.toggleFullScreenMode.bind(this);
    this.handleRequestShowSyncLogs = this.handleRequestShowSyncLogs.bind(this);
    this.requestShowApiUsageModal = this.requestShowApiUsageModal.bind(this);
    this.handleRequestShowOrganizationSyncPermissions = this.handleRequestShowOrganizationSyncPermissions.bind(this);
    this.handleDownload = this.handleDownload.bind(this);
  }

  componentDidMount() {
    this.sync();
    this.props.dispatch(fetchTruVoiceClients());
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.onFirstDataRendered();
  }

  onFirstDataRendered() {
    if (this.gridApi) {
      delay(() => {
        const { width } = this.props.viewableDimensions;
        const allColumns = this.gridColumnApi.getColumns();
        const allColumnIds = map(allColumns, 'colId');
        this.gridColumnApi.autoSizeColumns(allColumnIds);
        let allWidths = 0;
        each(this.gridColumnApi.getColumns(), (col) => {
          allWidths += col.actualWidth;
        });
        const viewableWidth = width;
        if (allWidths < viewableWidth - 2) {
          this.gridApi.sizeColumnsToFit();
        }
        this.gridApi.hideOverlay();
      }, 100);
    }
  }

  onChangeClientIds(clientIds) {
    const { editingOrganization } = this.state;
    if (!editingOrganization) {
      return;
    }
    const orgId = editingOrganization._id;
    this.setState({ updating: { ...this.setState.updating, [orgId]: true } });
    // const params = { tru_voice_clients: first(clientIds) }; // only 1 client per org
    const params = { tru_voice_clients: clientIds }; // only 1 client per org
    this.props.dispatch(requestUpdateOrganization(orgId, params)).then(
      () => {
        this.setState(
          { updating: { ...this.setState.updating, [orgId]: false } },
          () => {
            this.props.dispatch(resetTVProductMappings());
            this.props.dispatch(resetTVCollectorMappings());
            this.props.dispatch(resetTVPrograms());
          },
        );
      },
      () => {
        this.setState({ updating: { ...this.setState.updating, [orgId]: false } });
      },
    );
  }

  onResizeTopBar(w, topBarHeight) {
    this.setState({ topBarHeight });
  }

  sync() {
    this.setState({ loading: true, error: null });
    this.props.dispatch(fetchAllOrganizations({ stats: true })).then(
      () => {
        this.setState({ loading: false, error: null });
      },
      (error) => {
        this.setState({ loading: false, error });
      },
    );
  }

  /** Open the delete request popup modal */
  handleRequestDelete(editingOrganization) {
    this.setState({ editingOrganization, showDeleteModal: true });
  }

  handleSearch(query) {
    if (this.gridApi) {
      this.gridApi.setQuickFilter(query);
    }
  }

  handleRequestEdit(editingOrganization) {
    this.setState({ editingOrganization, showEditingModal: true });
  }

  handleRequestSync(editingOrganization) {
    this.setState({ editingOrganization, showSyncModal: true });
  }

  handleRequestCreateDemo(editingOrganization) {
    this.setState({ editingOrganization, showCreateDemoModal: true });
  }

  handleEditInvitationExclusionList(
    editingInvitationExclusionListOrganization,
  ) {
    this.setState({ editingInvitationExclusionListOrganization });
  }

  handleAddOrg() {
    if (this.gridApi) {
      this.gridApi.refreshCells({ force: true });
    }
  }

  requestShowAppUserModal(showOrganizationAppUser) {
    this.setState({ showOrganizationAppUser, showOrganizationAppUserModal: true });
  }

  requestShowApiUsageModal(showApiUsageOrganization) {
    this.setState({ showApiUsageOrganization, showApiUsageOrganizationModal: showApiUsageOrganization !== null });
  }

  requestShowSAMLModal(showOrganizationSAMLSettings) {
    this.setState({ showOrganizationSAMLSettings, showOrganizationSAMLModal: true });
  }

  handleRequestShowSyncLogs(showSyncLogOrganization) {
    this.setState({ showSyncLogOrganization });
  }

  handleRequestShowOrganizationSyncPermissions(showSyncOrganizationSyncPermissions) {
    this.setState({ showSyncOrganizationSyncPermissions });
  }

  handleDownload() {
    if (this.gridApi && this.gridColumnApi) {
      const allColumnKeys = this.gridColumnApi.getAllColumns()
        .map((col) => col.colId);
      const excludedColumnKeys = ['TRUVOICE', 'domainAuthorized', 'ACTIONS'];
      const columnKeys = allColumnKeys.filter((col) => excludedColumnKeys.indexOf(col) === -1);

      const params = {
        columnGroups: true,
        fileName: 'Organizations - TruSales',
        sheetName: 'Organization',
        exportMode: 'xlsx',
        columnKeys,
      };

      this.gridApi.exportDataAsExcel(params);
    }
  }

  nameColumnCellRendererSelector(params) {
    if (!params || !params.data) {
      return null;
    }
    const { deleting, updating } = this.state;
    const { data } = params;
    const disabled = deleting[data._id] || updating[data._id];
    return {
      params: {
        disabled,
        detailUrl: '/admin/organizations/',
      },
      component: OrganizationNameRenderer,
    };
  }

  actionColumnCellRendererSelector(params) {
    if (!params || !params.data) {
      return null;
    }
    const { loginUser, organizations } = this.props;
    const { deleting, updating } = this.state;
    const { data } = params;
    const { role } = loginUser;
    const canEdit = role === 'superadmin' || role === 'admin' || role === 'pi';
    const canDelete = role === 'superadmin';

    const { items } = organizations;
    const { childIndex } = params.node;
    const dropup = childIndex >= items.length - 6;
    return {
      params: {
        deleting: deleting[data._id] === true,
        updating: updating[data._id] === true,
        canEdit,
        canDelete,
        requestEdit: this.handleRequestEdit,
        requestSync: this.handleRequestSync,
        requestCreateDemo: this.handleRequestCreateDemo,
        requestDelete: this.handleRequestDelete,
        requestEditInvitationExclusionList: this.handleEditInvitationExclusionList,
        requestShowAppUserModal: this.requestShowAppUserModal,
        requestShowSAMLModal: this.requestShowSAMLModal,
        dropup,
      },
      component: ActionRenderer,
    };
  }

  userRoleCountColumnCellRendererSelector(params) {
    if (!params || !params.data) {
      return null;
    }
    return {
      params: {
        detailUrl: `/admin/organizations/`,
        openModal: (editingOrganization, role, connected, license) => {
          this.setState({
            showUserListByRole: true,
            editingOrganization,
            role,
            connected,
            license,
          });
        },
      },
      component: UserRoleCountRenderer,
    };
  }

  lastSyncedColumnCellRendererSelector(params) {
    if (!params) {
      return null;
    }
    const { value } = params;
    if (value) {
      return {
        params: {},
        component: OrganizationLastSyncRenderer,
      };
    }
    return {
      component: EmptyCellRenderer,
    };
  }

  estimateColumnCellRendererSelector(params) {
    if (!params) {
      return null;
    }
    const { value } = params;
    if (value) {
      return {
        params: {},
      };
    }
    return {
      component: EmptyCellRenderer,
    };
  }

  apiUsageColumnCellRendererSelector(params) {
    if (!params) {
      return null;
    }
    const { value } = params;
    if (value) {
      return {
        component: NumberRenderer,
        params: {
          onClick: (e) => {
            e.preventDefault();
            this.requestShowApiUsageModal(params.data);
          },
        },
      };
    }
    return {
      component: EmptyCellRenderer,
    };
  }

  toggleFullScreenMode() {
    this.setState({ fullScreenMode: !this.state.fullScreenMode });
  }

  estimateColumnValueGetter(params) {
    if (!params || params.node.group) {
      return null;
    }
    const { data } = params;
    const value = data.last_synced_duration;
    if (value) {
      return moment.duration(value, 'seconds').humanize();
    }
    return null;
  }

  truvoiceColumnCellRendererSelector(params) {
    if (!params || !params.data) {
      return null;
    }
    const { deleting, updating } = this.state;
    const { data } = params;
    const disabled = deleting[data._id] || updating[data._id];
    return {
      params: {
        disabled,
        requestEditOrganiztion: (editingOrganization) => {
          this.setState({ showAssignModal: true, editingOrganization });
        },
      },
      component: TruVoiceRenderer,
    };
  }

  renderTruVoiceAssignModal() {
    const {
      showAssignModal,
      deleting,
      updating,
      editingOrganization,
    } = this.state;
    let disabled = true;
    if (!editingOrganization) {
      return null;
    }
    disabled =
      deleting[editingOrganization._id] || updating[editingOrganization._id];
    return (
      <TruVoiceClientsAssignModal
        show={showAssignModal}
        disabled={disabled}
        onHide={() => {
          this.setState({ showAssignModal: false, editingOrganization: null });
        }}
        onClientChange={this.onChangeClientIds}
        organization={editingOrganization}
      />
    );
  }

  renderUserRoleListModal() {
    const {
      showUserListByRole,
      editingOrganization,
      role,
      connected,
      license,
    } = this.state;

    return (
      <UserRoleListModal
        show={showUserListByRole}
        onHide={() => {
          this.setState({
            showUserListByRole: false,
          });
        }}
        organization={editingOrganization}
        role={role}
        connected={connected}
        license={license}
        dispatch={this.props.dispatch}
      />
    );
  }

  renderFullScreenToggle() {
    const { fullScreenMode } = this.state;
    const description = fullScreenMode
      ? 'Exit Full Screen'
      : 'Enter Full Screen';
    return (
      <span>
        &nbsp;&nbsp;
        <OverlayTrigger
          placement={fullScreenMode ? 'bottom' : 'top'}
          overlay={<Tooltip id='full-screen-tip'>{description}</Tooltip>}
        >
          <Button bsStyle='link' onClick={this.toggleFullScreenMode}>
            <Fa name={fullScreenMode ? 'compress' : 'expand'} />
          </Button>
        </OverlayTrigger>
      </span>
    );
  }

  renderDownloadButton() {
    if (!this.gridApi) {
      return null;
    }
    return (
      <span>
        &nbsp;&nbsp;
        <OverlayTrigger
          placement='top'
          overlay={<Tooltip id='custom-field-download-tip'>Export as Excel File</Tooltip>}
        >
          <Button bsStyle='link' onClick={this.handleDownload}>
            <Fa name='download' />
          </Button>
        </OverlayTrigger>
      </span>
    );
  }

  renderResults() {
    const { organizations, viewableDimensions, loginUser } = this.props;
    const { items } = organizations;
    const { role } = loginUser;
    const isSuperAdmin = role === 'superadmin';
    const isAdmin = role === 'admin'; // https://github.com/lumen-software/TruSales/issues/1683
    const canAdd = isSuperAdmin || isAdmin;
    const canEdit = role === 'superadmin' || role === 'admin';
    const canDelete = role === 'superadmin';
    const canDownload = role === 'superadmin' || role === 'admin' || role === 'pi';

    const { loading, fullScreenMode, topBarHeight } = this.state;

    const columnDefs = [
      {
        headerName: 'Name',
        pinned: 'left',
        colId: 'NAME',
        suppressMovable: true,
        width: 300,
        cellRendererSelector: this.nameColumnCellRendererSelector,
        valueGetter: (params) => params?.data?.display_name || params?.data?.name || '',
        getQuickFilterText: (params) => `${params?.data?.display_name || ''} ${params?.data?.name || ''}`,
      },
      ...((isSuperAdmin || isAdmin)
        ? [{
            headerName: 'TruVoice Connections',
            field: '_id',
            colId: 'TRUVOICE',
            cellRendererSelector: this.truvoiceColumnCellRendererSelector,
            menuTabs: ['generalMenuTab', 'columnsMenuTab'],
          }]
        : []),
      ...(canEdit
        ? [{
            headerName: 'Bots Version',
            field: 'bot_version',
            colId: 'BOT_VERSION',
            cellRenderer: BotVersionRenderer,
            enableRowGroup: true,
          }]
        : []),
      {
        headerName: 'Last Synced',
        field: 'last_synced_date',
        colId: 'LAST_SYNCED',
        type: 'dateColumn',
        cellRendererParams: {
          showError: true,
          requestShowSyncLogs: this.handleRequestShowSyncLogs,
        },
        cellRendererSelector: this.lastSyncedColumnCellRendererSelector,
      },
      {
        headerName: 'Scheduled Sync Time',
        field: 'next_sync_date',
        colId: 'NEXT_SYNCED',
        type: 'dateColumn',
        cellRendererSelector: this.lastSyncedColumnCellRendererSelector,
      },
      {
        headerName: 'Estimate Sync Time',
        field: 'last_synced_duration',
        colId: 'ESTIMATE_SYNC_TIME',
        cellRendererSelector: this.estimateColumnCellRendererSelector,
        valueGetter: this.estimateColumnValueGetter,
        enableRowGroup: true,
      },
      {
        headerName: 'Api Usage',
        field: 'total_api_usages',
        colId: 'TOTAL_API_USAGES',
        filter: 'agNumberColumnFilter',
        cellRendererSelector: this.apiUsageColumnCellRendererSelector,
        enableValue: true,
      },
      {
        headerName: 'CRM ID',
        field: 'organization_id',
        colId: 'ORGID',
        cellRenderer: OrganizationIdRenderer,
      },
      {
        headerName: 'CRM Type',
        field: 'type',
        colId: 'type',
        cellRenderer: OrganizationTypeRenderer,
        cellRendererParams: {
          requestShowOrganizationSyncPermissions: this.handleRequestShowOrganizationSyncPermissions
        },
        enableRowGroup: true,
      },
      {
        headerName: 'CRM Edition',
        field: 'organization_type',
        colId: 'edition',
        enableRowGroup: true,
      },
      {
        headerName: 'Domain Authorized',
        field: '_id',
        colId: 'domainAuthorized',
        cellRenderer: TruVoiceDomainRenderer,
        menuTabs: ['generalMenuTab', 'columnsMenuTab'],
      },
      {
        headerName: 'Sales Reps',
        field: 'stats.salesReps',
        colId: 'SALESREPS',
        filter: 'agNumberColumnFilter',
        cellRendererParams: {
          role: 'user',
          connected: true,
          license: true,
        },
        cellRendererSelector: this.userRoleCountColumnCellRendererSelector,
        enableValue: true,
      },
      {
        headerName: 'Sales Manager',
        field: 'stats.managers',
        colId: 'SALESMANAGER',
        filter: 'agNumberColumnFilter',
        cellRendererParams: {
          role: 'manager',
          connected: true,
          license: true,
        },
        cellRendererSelector: this.userRoleCountColumnCellRendererSelector,
        enableValue: true,
      },
      {
        headerName: 'Admins',
        field: 'stats.admins',
        colId: 'ADMINS',
        filter: 'agNumberColumnFilter',
        cellRendererParams: {
          role: 'admin',
          connected: true,
          license: true,
        },
        cellRendererSelector: this.userRoleCountColumnCellRendererSelector,
        enableValue: true,
      },
      {
        headerName: 'Connected',
        field: 'stats.connected',
        colId: 'CONNECTED',
        filter: 'agNumberColumnFilter',
        cellRendererParams: {
          connected: true,
          license: true,
        },
        cellRendererSelector: this.userRoleCountColumnCellRendererSelector,
        enableValue: true,
      },
      ...((canEdit || canDelete) ?
        [{
          headerName: 'Actions',
          field: '_id',
          pinned: 'right',
          colId: 'ACTIONS',
          suppressMovable: true,
          suppressMenu: true,
          sortable: false,
          filter: false,
          width: 120,
          lockPosition: 'right',
          lockVisible: true,
          suppressColumnsToolPanel: true,
          suppressFiltersToolPanel: true,
          cellRendererSelector: this.actionColumnCellRendererSelector,
        }]
      : []),
    ];

    const { height } = viewableDimensions;
    const tableHeight = fullScreenMode
      ? Math.max(height - topBarHeight, 100)
      : height;

    return (
      <div>
        {(isSuperAdmin || isAdmin) && this.renderTruVoiceAssignModal()}
        {this.state.showUserListByRole && this.renderUserRoleListModal()}
        {this.state.showEditingModal &&
          this.state.editingOrganization !== null && (
            <div className='invisible' style={{ height: 0 }}>
              <AddOrganizationButton
                organization={this.state.editingOrganization}
                showForm
                onModalClose={() => {
                  this.setState({
                    showEditingModal: false,
                    editingOrganization: null,
                  });
                }}
                onUpdate={() => {
                  this.setState(
                    { showEditingModal: false, editingOrganization: null },
                    this.handleAddOrg,
                  );
                }}
                onAdd={this.handleAddOrg}
              />
            </div>
          )}
        {this.state.showDeleteModal &&
          this.state.editingOrganization !== null &&
          !this.state.editingOrganization.organization_id !== null && (
            <OrganizationDelete
              organization={this.state.editingOrganization}
              onClose={(deleting) => {
                this.setState({
                  ...(deleting ? { deleting: { ...this.state.deleting, ...deleting } } : {}),
                  showDeleteModal: false,
                  editingOrganization: null,
                });
                if (this.gridApi && deleting) {
                  this.gridApi.refreshCells({ force: true });
                }
              }}
              onError={(error, deleting) => {
                if (error && error.data && error.data.message) {
                  const el = <div>{error.data.message}</div>;
                  this.context.addNotification(el, { type: 'error', autoClose: false });
                }
                if (this.gridApi && deleting) {
                  this.setState({ deleting: { ...this.state.deleting, ...deleting } });
                  this.gridApi.refreshCells({ force: true });
                }
              }}
              showConfirm
            />
          )}
        {this.state.showSyncModal &&
          this.state.editingOrganization !== null &&
          !this.state.editingOrganization.is_demo &&
          !this.state.editingOrganization.organization_id !== null && (
            <OrganizationResync
              organization={this.state.editingOrganization}
              onClose={() => {
                this.setState({
                  showSyncModal: false,
                  editingOrganization: null,
                });
              }}
              showConfirm
            />
          )}
        {this.state.showCreateDemoModal &&
          this.state.editingOrganization !== null &&
          !this.state.editingOrganization.is_demo &&
          !this.state.editingOrganization.organization_id !== null && (
            <CreateDemoOrganizationButton
              onAdd={this.handleAddOrg}
              organization={this.state.editingOrganization}
              showForm
              onClose={() => {
                this.setState({
                  showCreateDemoModal: false,
                  editingOrganization: null,
                });
              }}
            />
          )}
        <div
          ref={(el) => {
            this._el = el;
          }}>
          <Veil anchorElement={this._el} fullScreenMode={fullScreenMode}>
            <nav className='navbar navbar-default navbar-controls'>
              <form className='navbar-form navbar-left'>
                <SearchField collapsible={false} onSearch={this.handleSearch} />
              </form>
              <div className='navbar-form navbar-right' style={{ paddingRight: 30 }}>
                {canAdd && !loading && <span>
                  <TruVoiceResync className='btn btn-default' />
                  &nbsp;&nbsp;&nbsp;
                  <AddOrganizationButton />
                </span>}
                {canDownload && this.renderDownloadButton()}
                {this.renderFullScreenToggle()}
              </div>
              <ReactResizeDetector
                handleHeight
                onResize={this.onResizeTopBar}
              />
            </nav>
            <div
              className='ag-theme-alpine'
              style={{ width: '100%', height: `${tableHeight}px` }}>
              <AgGridReact
                reactNext
                enableColResize
                enableSorting
                animateRows
                suppressColumnVirtualisation
                columnDefs={columnDefs}
                getRowId={({ data }) => data._id}
                onGridReady={this.onGridReady}
                onFirstDataRendered={this.onFirstDataRendered}
                rowData={items}
                sideBar={{
                  toolPanels: [{
                    id: 'columns',
                    labelDefault: 'Columns',
                    labelKey: 'columns',
                    iconKey: 'columns',
                    toolPanel: 'agColumnsToolPanel',
                    toolPanelParams: {
                      suppressColumnFilter: true,
                      suppressColumnSelectAll: true,
                      suppressColumnExpandAll: true,
                    },
                  }],
                }}
                defaultColDef={{
                  resizable: true,
                  filter: true,
                  sortable: true,
                  suppressMenu: false,
                }}
                columnTypes={{
                  dateColumn: {
                    filter: 'agDateColumnFilter',
                    filterParams: {
                      comparator: dateComparator,
                    },
                  },
                }}
                components={{
                  agColumnHeader: CustomHeader,
                }}
              />
            </div>
          </Veil>
        </div>
        <div style={{ height: '170px' }} />
        {this.state.editingInvitationExclusionListOrganization !== null &&
          <InvitationExclusionModal
            organization={this.state.editingInvitationExclusionListOrganization}
            onClose={() => {
              this.setState({ editingInvitationExclusionListOrganization: null });
            }}
            showModal={
              this.state.editingInvitationExclusionListOrganization !== null
            }
            isModal
          />
        }
        <SyncLogModal
          organization={this.state.showSyncLogOrganization}
          onClose={this.handleRequestShowSyncLogs}
        />
        <OrganizationSyncPermissions
          organization={this.state.showSyncOrganizationSyncPermissions}
          onClose={this.handleRequestShowOrganizationSyncPermissions}
        />
        {this.state.showOrganizationAppUser !== null &&
          <AppUserModal
            key={this.state.showOrganizationAppUser._id}
            organization={this.state.showOrganizationAppUser}
            show={this.state.showOrganizationAppUserModal}
            onModalClose={() => {
              this.setState({ showOrganizationAppUserModal: false });
            }}
          />
        }

        {this.state.showApiUsageOrganization !== null &&
          <ApiUsageModal
            key={this.state.showApiUsageOrganization._id}
            organization={this.state.showApiUsageOrganization}
            show={this.state.showApiUsageOrganizationModal}
            onModalClose={() => {
              this.setState({ showApiUsageOrganizationModal: false });
            }}
          />
        }

        {this.state.showOrganizationSAMLSettings !== null &&
          <SAMLForm
            key={this.state.showOrganizationSAMLSettings._id}
            organization={this.state.showOrganizationSAMLSettings}
            show={this.state.showOrganizationSAMLModal}
            onModalClose={() => {
              this.setState({ showOrganizationSAMLModal: false });
            }}
          />
        }
      </div>
    );
  }

  render() {
    const { loading, error } = this.state;
    return (
      <div>
        <Helmet title='All Organizations' />
        <p />
        <div className='container'>
          {loading && <ProgressBar />}
          {!loading && error === null && this.renderResults()}
        </div>
      </div>
    );
  }
}

// SetupPage.need = [() => { return fetchStages(); }];

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    loginUser: getUser(state),
    organizations: getAllOrganizations(state),
    viewableDimensions: getViewableDimensions(state),
    truVoiceClients: getTruVoiceClients(state),
    truVoiceClientsLoading: getTruVoiceClientsLoading(state),
    truVoiceClientsLoaded: getTruVoiceClientsLoaded(state),
  };
}

OrganizationIndexPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  viewableDimensions: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
  }).isRequired,
  organizations: PropTypes.shape({
    items: PropTypes.array.isRequired,
    meta: PropTypes.object.isRequired,
  }).isRequired,
  loginUser: PropTypes.shape({
    _id: PropTypes.string,
    role: PropTypes.string,
  }).isRequired,
};

OrganizationIndexPage.contextTypes = {
  router: PropTypes.object,
  addNotification: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(OrganizationIndexPage);
